// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"19a5506f19df079e3812","1642":"a118a4db4cfaa015f956","2983":"1f728bb13d4fd80b6bef","9279":"460048c8db22e016b900"}[chunkId] + "";
};